import { isShopAvailable } from "@phn/utility/helper/shop-helper";
import { Application, ApplicationType } from "@phn/utility/constants/app";
import { navContentStore } from "@phn/state/nav-content-store";
import { Component, Element, h, Host, Prop, State } from "@stencil/core";
import windowService from "@phn/services/window-service";
import {
  NavigationMode,
  NavigationModeType,
  NavigationTheme,
  NavigationThemeType,
} from "@phn/utility/constants";
import animationManager from "@phn/services/animation-manager";
import { getHTMLElement, loadRootElement } from "@phn/utility/helper";

@Component({
  tag: "phn-wrapper",
  styleUrl: "wrapper.scss",
  scoped: true,
})
export class Wrapper {
  @Prop() locale!: string;

  @Prop() breakpoint!: number;

  @Prop() loadingContent = false;

  @Prop() receivedContent = false;

  @Prop() theme: NavigationThemeType = NavigationTheme.light;

  @Prop() mode: NavigationModeType = NavigationMode.navbar;

  @Prop() app: ApplicationType = Application.default;

  @Prop() displayLogoOnly = false;

  @Prop() limitedWidth = false;

  @State() showCountryRecommender = windowService.redirected;

  @State() countryRecommenderClosed = false;

  @Element() el!: HTMLPhnWrapperElement;

  componentWillLoad(): void {
    this.el.style.setProperty(
      "--scrollbar-width",
      windowService.getScrollbarWidth(),
    );

    loadRootElement(this.el);
    animationManager.initialize();
  }

  render(): HTMLPhnWrapperElement {
    const { shop, countryRecommender, accessibilityStatement } =
      navContentStore.state;

    const showCountryRecommender =
      this.showCountryRecommender &&
      !this.countryRecommenderClosed &&
      this.receivedContent;

    return (
      <Host>
        {showCountryRecommender ? (
          <phn-country-recommender
            locale={this.locale}
            content={countryRecommender}
            role="region"
            aria-label="Change recommended Region or Language"
            onBannerClosed={() => {
              this.countryRecommenderClosed = true;
            }}
          />
        ) : null}

        {this.locale === "en-US" && accessibilityStatement !== null ? (
          <a
            aria-label="accessibility statement"
            class="screenreader-only"
            href={accessibilityStatement.link}
          >
            {accessibilityStatement.text}
          </a>
        ) : null}

        <phn-level-0
          theme={this.theme}
          mode={this.mode}
          locale={this.locale}
          loadingContent={this.loadingContent}
          receivedContent={this.receivedContent}
          breakpoint={this.breakpoint}
          app={this.app}
          displayLogoOnly={this.displayLogoOnly}
          limitedWidth={this.limitedWidth}
        >
          {isShopAvailable(shop, this.locale, this.app) ? (
            <div slot="contextual_drawer_header">
              <slot name="contextual_drawer_header"></slot>
            </div>
          ) : null}
        </phn-level-0>

        <div
          id="main"
          class="main-content"
          onBlur={(e) => {
            const el = getHTMLElement(e.currentTarget);
            if (el !== null) {
              el.removeAttribute("tabIndex");
            }
          }}
        />
      </Host>
    );
  }
}
